import { ReactNode } from "react";
import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export interface CardTableActionsProps {
  children: ReactNode[];
}

export const ButtonWrapper = styled("span")`
  & > *:not(:last-child) {
    margin-right: 15px;
  }
`;

export const CardActionButton = styled(Button)`
  border-radius: 0;
  text-transform: none;
  font-weight: bold;
`;

export const CardTableActions = ({ children }: CardTableActionsProps) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {children.map((child, index) => (
        <ButtonWrapper key={index}>
          <Box sx={{ mr: "10px" }}>{child}</Box>
        </ButtonWrapper>
      ))}
    </Box>
  );
};
